console.log('[index.js] ===== BEST DEAL EXTRACT LOADED =====', new Date().toISOString());
import { getCustomPanelList, getVaVwTestsAndDiscountPanels, getDiscountMapAndSeasonalPromotionList, handleTestsAndBundlesFromPayload, parseBestDealSuggestionObj } from "./helpers.js";
import { getSuggestBundlesAndLeftOverTestsForNewVw, getTestIdsForBestDealFunc, replaceWithParentTests } from "../bestDealSuggestion/index.js";

import _ from "lodash";
import { applyConditionalDiscounts } from "../index.js";
import { getBestDealMapping } from "@/api/va-order-page/pricing/item/price.js";
import { handleBulletListPackageTests } from "../testAndPanelSelection/handleDuplicateTests.js";
/**
 * 
 * @param { Array } testIds - array of test ids 
 * @returns { Object } bestDealSuggestion - cheapest combination for the given test ids
 */
export async function getBestDealParams() {
  console.log('[index.js] ===== GET BEST DEAL PARAMS CALLED =====', new Date().toISOString());
  let { vaNodeList, vaRootNodeList, vwNodeList, vwRootNodeList, discountPanelList, dbsMappings, regenere, nutriproz } = await getVaVwTestsAndDiscountPanels(false, "usd", true);
  console.log('[index.js] getVaVwTestsAndDiscountPanels returned:', { regenere, nutriproz });

  let testNodeList = vaNodeList.concat(vwNodeList);
  // let payload = {
  //   currency: "usd",
  //   clinicId: 10136,
  //   customerId: 999997,
  //   accountType: "clinic"
  // }
  // let customPanelList = await getCustomPanelList(payload);
  let bundleList = discountPanelList;
  let { discountMap, seasonalPromotionList } = await getDiscountMapAndSeasonalPromotionList(discountPanelList, testNodeList);
  //   dbsMap: state.dbsMap,
  let { data: bestDealMappingData } = await getBestDealMapping()

  // Extract regenere and nutriproz ID lists
  // Handle both formats: array of IDs [731, 725] or array of objects [{testId: 731}, ...]
  const regenereIdList = (regenere || [])
    ?.map(t => typeof t === 'number' ? t : (t.testId || t.id)) || [];
  const nutriprozIdList = (nutriproz || [])
    ?.map(t => typeof t === 'number' ? t : (t.testId || t.id)) || [];

  // NY-specific filtering for NutriProZ (same logic as VA Portal)
  // Remove NutriProZ(725) for NY customer, & remove NutriProZ NY(726) for non-NY user
  let userInfo = null;
  try {
    userInfo = JSON.parse(localStorage.getItem("userInfo"));
  } catch (e) {}
  const nutriprozIdToRemove = getNutriprozIdToRemove(userInfo);
  const filteredNutriprozIds = nutriprozIdList.filter(id => id !== nutriprozIdToRemove);

  console.log('[getBestDealParams] ID lists:', {
    regenereIdList,
    nutriprozIdList,
    filteredNutriprozIds,
    nutriprozIdToRemove,
    vwRootNodeListIds: vwRootNodeList.map(n => n.id),
    vwRootNodeListLength: vwRootNodeList.length
  });

  // Helper function to get NutriProZ ID to remove based on user state
  function getNutriprozIdToRemove(userInfo) {
    if (!userInfo) return 726; // Default: remove NutriProZ NY for non-NY
    const rawState = userInfo.customer_state || userInfo.state || '';
    const userState = rawState ? getStateAbbreviation(rawState) : '';
    const isNYCustomer = userState.toUpperCase() === "NY";
    // Remove NutriProZ(725) for NY customer, & remove NutriProZ NY(726) for non-NY user
    return isNYCustomer ? 725 : 726;
  }

  // Helper function to get state abbreviation
  function getStateAbbreviation(rawState) {
    // Map full state names to abbreviations (can be extended)
    const stateMap = {
      "New York": "NY", "New York State": "NY",
      // Add more as needed
    };
    if (rawState.length <= 2) return rawState.toUpperCase(); // Already abbreviation
    return stateMap[rawState] || rawState.substring(0, 2).toUpperCase();
  }

  // Derive regenere node list from vwRootNodeList (same logic as VA Portal)
  // Filter by regenereIdList and sort by display name descending
  const regenereNodeList = vwRootNodeList
    .filter(node => regenereIdList.includes(node.id))
    .sort((a, b) => {
      const nameA = (a.value.displayName || a.value.testName || '').toLowerCase();
      const nameB = (b.value.displayName || b.value.testName || '').toLowerCase();
      return nameB.localeCompare(nameA);
    });

  // Derive nutriproz node list from vwRootNodeList (same logic as VA Portal)
  // Use filteredNutriprozIds to remove NY-specific tests
  const nutriprozNodeList = vwRootNodeList
    .filter(node => {
      console.log('[nutriproz filter]', { nodeId: node.id, nodeIdType: typeof node.id, nutriprozIdList: filteredNutriprozIds, isIncluded: filteredNutriprozIds.includes(node.id) });
      return filteredNutriprozIds.includes(node.id);
    });

  console.log('[getBestDealParams] Derived node lists:', {
    regenereNodeList: regenereNodeList.length,
    nutriprozNodeList: nutriprozNodeList.length
  });

  let supportObj = {
    testNodeList,
    bundleList,
    seasonalPromotionList,
    bestDealSupportMapping: bestDealMappingData,
    // VA/VW tree structure for UI tabs
    vaRootNodeList,
    vaNodeList,
    vwRootNodeList,
    vwNodeList,
    // Regenere/Nutriproz ID lists for filtering
    regenereIdList,
    nutriprozIdList,
    // Regenere/Nutriproz node lists for UI tabs (filtered from vwRootNodeList)
    regenereNodeList,
    nutriprozNodeList
  }
  return { supportObj, discountMap, dbsMappingData: dbsMappings };
}

export function getBestDealSuggestion(payload, supportObj, discountMap, dbsMappingData) { 
  let { testIds, discountPanelIds } = handleTestsAndBundlesFromPayload(payload);
  let isAnyThreeDBSPromoStart = supportObj.seasonalPromotionList.find(p => p.discountName === "3 for $700 Bundle") ? true: false;
  let modifiedTestIds = [...testIds];
  let { testNodeList, seasonalPromotionList, bundleList } = supportObj;

  // Figure out whether any testIds or discountPanelIds do not exist before getTestIdsForBestDeal
  let nonExistingTestIds = modifiedTestIds.filter(id => !testNodeList.some(node => node.id === id || node.value?.originalId === id));
  let nonExistingDiscountPanelIds = (discountPanelIds || []).filter(panelId => !bundleList.some(b => b.bundleId == panelId));

  handleBulletListPackageTests(testNodeList, modifiedTestIds);
  let testIdsForBestDeal = getTestIdsForBestDealFunc(supportObj, modifiedTestIds, discountPanelIds);
  
  let testList = testNodeList.map(node => node.value);

  testList.forEach(test => {
    test.isSelectForBestDeal = testIdsForBestDeal.includes(test.id);
  });
  const triggerItemList = testList.filter(t => testIdsForBestDeal.includes(t.id));
  applyConditionalDiscounts(testList, "isSelectForBestDeal", triggerItemList);
  testList.forEach(test => {
    delete test.isSelectForBestDeal;
  });
  // if is_dbs is given, use it directly; otherwise, check whether the order contains dbs item
  let isDbs = payload.is_dbs;
  if ([undefined, null].includes(isDbs)) {
    isDbs = testList.filter(t => testIdsForBestDeal.includes(t.id)).some(t => t.section === "at_home");
  }
  // Use new_vw specific function if user is in new_vw beta program
  let bestDealSuggestion = getSuggestBundlesAndLeftOverTestsForNewVw(testIdsForBestDeal, supportObj, discountMap, isDbs);
  // map the frontend use promotion id (negative value) to backend normal use
  // add category for each bundle : promo, food_zoomer or discount_bundle
  bestDealSuggestion.suggestBundleList.forEach(bundle => {
    if (bundle.appliedBundleId < 0) {
      let promo = seasonalPromotionList.find(p => p.bundleId === bundle.appliedBundleId);
      bundle.category = "promo";
      bundle.appliedBundleId = promo.id;
    } else {
      bundle.category = bundle.appliedZoomers ? "food_zoomer" : "discount_bundle";
    }
  });
  // check whether need to update price for heavy metal
  // 03/04/2025 update: remove following heavy metal price handling logic,
  // the price should be handled already in above best deal suggestion function
  // if (bestDealSuggestion.leftOverTestIdList.includes(181)) {
  //   if (isHeavyMetalSpecialPrice) { // heavy metal price change to 60
  //     // update best deal price by aubtracting the difference
  //     // between the heavy metal's price and 60
  //     let heavyMetalPrice = testList.find(t => t.id === 181).price;
  //     let diff = heavyMetalPrice - 60;
  //     let bestDealPrice = Number(bestDealSuggestion.bestDealPrice);
  //     bestDealSuggestion.bestDealPrice = (bestDealPrice - diff).toFixed(2);
  //   }
  // }
  // parse the bestDealSuggestion obj to api response
  let result = parseBestDealSuggestionObj(bestDealSuggestion);
  result.non_existing_test_ids = nonExistingTestIds.map(String);
  result.non_existing_discount_panel_ids = nonExistingDiscountPanelIds.map(String);
  return result;
}